import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import CandidateListForm from "@/lib/form/exam/CandidateListForm";
import _ from "lodash-es";
import EnumCandidate from "@/lib/enum/candidate";
import CandidateCreateForm from "@/lib/form/candidate/CandidateCreateForm";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import { StructParam } from "@/lib/form/candidate/CandidateCreateForm";
import { StructCandidateData } from "../../form/candidate/CandidateCreateForm";
import CandidateRepeatCreateForm from "@/lib/form/candidate/CandidateRepeatCreateForm";
import CandidateMRepeatCreateForm, {
  RepeatMCreate
} from "@/lib/form/candidate/CandidateMRepeatCreateForm";
import CandidateExportForm from "@/lib/form/candidate/CandidateExportForm";
import Auth from "@/lib/common/auth";
import V from "@/store/vuex-store";
import { EnumTagType } from "@/lib/enum/tags";

export class ExamInfo extends Model {
  examId = "";
  companyId = "";
  scoreAll = 0;
  name = "";
  closeUpdate = 0;
  questionList = [];
  questionCount = 0;
  candidateType = 0;
  connectCode = "";

  static getInfo(examId: string) {
    return request.post("onlineExam/exam/get", { examId }).then(resp => {
      return new ExamInfo().assign(resp.data.data);
    });
  }

  static getList() {
    return request
      .post("aiExam/company/examAll", {
        companyId: Auth.companyId,
        examType: V.getExamType
      })
      .then(resp => {
        const list = [];
        if (resp.data.code === 0) {
          for (const item of resp.data.data.list) {
            list.push(new ExamInfo().assign(item));
          }
          return list;
        }
        return null;
      });
  }

  static getListFilterd(judgeId = 0) {
    return request
      .post("/aiExam/judge/allExamList", {
        companyId: Auth.companyId,
        judgeId: judgeId
      })
      .then(resp => {
        const list = [];
        if (resp.data.code === 0) {
          for (const item of resp.data.data.list) {
            list.push(new ExamInfo().assign(item));
          }
          return list;
        }
        return null;
      });
  }
}

export class CandidateListExportParams {
  companyId = 0;
  examId = 0;
  asCompany = 0;
  isFsk = 0;
  examType = "";
}

export class CandidateMCreateParseParams extends ExamGetForm {
  ossUrl = "";
  needExport = 0;
  needSort = 0;
}

export class CandidateParam {
  phone = "";
  showName = "";
}

export class CandidateGet {
  candidateId = 0;
  companyId = 0;
  sendMessageTime = "";
  sendMessageType = 0;
  sendMessage = 1;
}

export class MDelete {
  companyId = 0;
  candidateIdList: number[] = [];
}

export class SendAsk extends MDelete {
  sendMessageTime = "";
  sendMessageType = 0;
  sendMessage = 0;
}

export class UpdateCandidate extends CandidateGet {
  showName = "";
  phone = "";
  paramList: StructParam[] = new Array<StructParam>(); //登记信息配置
}

export class CandidateDeleteTags {
  connectCode = 0;
  candidateId = 0;
  companyId = 0;
  tags: string[] = [];
  passwd = "";
  judgeOutId = "";
  tagType = EnumTagType.EnumTagTypeDefault;
}

export class CandidateMCreateParams {
  examId = "";
  companyId = "";
  candidateList: StructCandidateData[] = new Array<StructCandidateData>();
  sendMessage: any = 1;
  sendMessageType = 0;
  sendMessageTime = "";
  tagList: string[] = [];
}
export class CandidateMCreateParamsJob {
  jobId = "";
  companyId = "";
  whiteUserList: StructCandidateData[] = new Array<StructCandidateData>();
  sendMessage: any = 1;
  mobileMessageTemplateId = 0;
  emailMessageTemplateId = 0;
}

export class CandidateList {
  candidateId = 0;
  auditStatus = 0;
  auditDesc = "";
}

export class CandidateMAudit {
  companyId = 0;
  candidateList: CandidateList[] = [new CandidateList()];
}

export default class Candidate extends Model {
  showName = "";
  phone = "";
  connectCode = "";
  scoreAll = 0;
  auditStatus = 0;
  submitTime = "";
  createdTime = "";
  auditTime = "";
  beginTime = "";
  examInfo = new ExamInfo();
  submitStatus = 0;
  tags: string[] = [""];
  afterUpdateNrProject = 0;
  score = 0;

  getSubmitStatusName(): string {
    let statusText = "";
    switch (this.submitStatus) {
      case 0:
        statusText = "未登记";
        break;
      case 1:
        statusText = "答题中";
        break;
      case 2:
        statusText = "已交卷";
        break;
      case 3:
        statusText = "已登记";
        break;
    }
    return statusText;
  }
  getAuditStatusName(): string {
    const name = _.get(EnumCandidate.auditStatusListData, this.auditStatus);
    return name ? name : "未阅卷";
  }

  isAuditWait() {
    return this.auditStatus === 2;
  }
  isAuditAllow() {
    return this.auditStatus === 1;
  }
  isAuditDeny() {
    return this.auditStatus === 3;
  }

  isAudited(): boolean {
    return this.auditStatus !== 0;
  }

  static list(args: CandidateListForm) {
    return request
      .post("onlineExam/audit/candidateList", {
        examId: args.examId,
        auditStatus: isNaN(parseInt(args.auditStatus))
          ? []
          : [args.auditStatus],
        submitStatus: args.submitStatus === "" ? [] : [args.submitStatus],
        showName: args.showName,
        sortKey: args.order,
        sortDict: args.orderDirection,
        page: args.page,
        pageSize: args.pageSize
      })
      .then(resp => {
        const candidates = new Array<Candidate>();
        _.forEach(resp.data.data.list, item => {
          const candidate = new Candidate();
          candidate.assign(item);
          candidates.push(candidate);
        });
        return candidates;
      });
  }

  static candidateCreate(candidateCreaateForm: CandidateCreateForm) {
    return request
      .post("aiExam/candidate/createNew", candidateCreaateForm)
      .then(resp => {
        return resp.data;
      });
  }

  static candidateListExport(exportParams: CandidateListExportParams) {
    exportParams = { ...exportParams, examType: V.getExamType };
    return request
      .post("aiExam/candidate/listExport", exportParams)
      .then(resp => {
        return resp.data;
      });
  }

  static candidateAllExport(exportParams: CandidateExportForm) {
    return request
      .post("aiExam/sf/exportCandidate", exportParams)
      .then(resp => {
        return resp.data;
      });
  }

  static candidateAnswerAllExport(exportParams: CandidateExportForm) {
    return request
      .post("aiExam/sf/exportCandidateAnswer", exportParams)
      .then(resp => {
        return resp.data;
      });
  }

  static kfcCandidateAllExport(exportParams: CandidateExportForm) {
    return request
      .post("aiExam/candidate/exportAll", exportParams)
      .then(resp => {
        return resp.data;
      });
  }

  static mklCandidateAllExport(exportParams: CandidateExportForm) {
    return request
      .post("aiExam/mkl/exportCandidate", exportParams)
      .then(resp => {
        return resp.data;
      });
  }

  static candidateMCreateParse(
    candidateMCreateParseParams: CandidateMCreateParseParams
  ) {
    return request
      .post("aiExam/candidate/mCreateParseNew", candidateMCreateParseParams)
      .then(resp => {
        return resp.data;
      });
  }

  static candidateMCreateParseV3(
    candidateMCreateParseParams: CandidateMCreateParseParams
  ) {
    return request
      .post("aiExam/candidate/mCreateParseV3", candidateMCreateParseParams)
      .then(resp => resp.data);
  }

  static candidateMCreate(candidateMCreateParams: CandidateMCreateParams) {
    return request
      .post("aiExam/candidate/mCreateNew", candidateMCreateParams)
      .then(resp => {
        return resp.data;
      });
  }

  static candidateMCreateV3(candidateMCreateParams: any) {
    return request
      .post("aiExam/candidate/mCreateV3", candidateMCreateParams)
      .then(resp => resp.data);
  }

  static candidateDeleteTags(candidateDeleteTags: CandidateDeleteTags) {
    return request
      .post("aiExam/candidate/deleteTags", candidateDeleteTags)
      .then(resp => {
        return resp.data;
      });
  }
  static candidateDeleteTagsHr(candidateDeleteTags: CandidateDeleteTags) {
    return request
      .post("aiExam/auditPublic/deleteTags", candidateDeleteTags)
      .then(resp => {
        return resp.data;
      });
  }

  static getCandidateInfo(candidateGet: CandidateGet) {
    return request.post("aiExam/candidate/get", candidateGet).then(resp => {
      return resp.data;
    });
  }

  static updateCandidate(updateCandidateForm: UpdateCandidate) {
    return request
      .post("aiExam/candidate/update", updateCandidateForm)
      .then(resp => {
        return resp.data;
      });
  }

  static noticeCandidate(candidateGet: CandidateGet) {
    return request
      .post("aiExam/candidate/sendMessage", candidateGet)
      .then(resp => {
        return resp.data;
      });
  }
  //新版发送邀请通知 固定双发
  static sendAsk(params: CandidateGet) {
    return request
      .post("aiExam/message/candidateSend", {
        ...params,
        env: 1,
        sendMobile: true,
        sendEmail: true
      })
      .then(resp => {
        return resp.data;
      });
  }
  //新版发送结果通知 固定双发
  static sendRes(params: CandidateGet) {
    return request
      .post("aiExam/message/candidateSend", {
        ...params,
        env: 10,
        sendMobile: true,
        sendEmail: true
      })
      .then(resp => {
        return resp.data;
      });
  }

  static autoSubmitAndRepeat(data: any) {
    return request
      .post("aiExam/candidate/autoSubmitAndRepeatCreate", data)
      .then(resp => {
        return resp.data;
      });
  }

  static delCandidate(candidateGet: CandidateGet) {
    return request.post("aiExam/candidate/delete", candidateGet).then(resp => {
      return resp.data;
    });
  }

  static mAuditCandidate(candidateMAudit: CandidateMAudit) {
    return request
      .post("aiExam/candidate/mAudit", candidateMAudit)
      .then(resp => {
        return resp.data;
      });
  }

  static mDelete(mDelete: MDelete) {
    return request.post("aiExam/candidate/mDelete", mDelete).then(resp => {
      return resp.data;
    });
  }

  static mSendMessage(mSend: MDelete) {
    return request.post("aiExam/candidate/mSendMessage", mSend).then(resp => {
      return resp.data;
    });
  }
  //新版发送通知 固定双发
  static mSendAsk(params: SendAsk, env: number) {
    return request
      .post("aiExam/message/candidateMSend", {
        ...params,
        env: env,
        sendMobile: true,
        sendEmail: true
      })
      .then(resp => {
        return resp.data;
      });
  }

  static candidateBuy(buyForm: CandidateGet) {
    return request.post("aiExam/candidate/buy", buyForm).then(resp => {
      return resp.data;
    });
  }

  static candidateRepeatCreate(repeatForm: CandidateRepeatCreateForm) {
    return request
      .post("aiExam/candidate/repeatCreate", repeatForm)
      .then(resp => {
        return resp.data;
      });
  }
  static checkEmail(p: any) {
    return request.post("aiExam/exam/hasEmail", p).then(resp => {
      return resp.data;
    });
  }

  static candidateMRepeatCreate(mRepeatForm: CandidateMRepeatCreateForm) {
    return request
      .post("/aiExam/candidate/repeatMCreate", mRepeatForm)
      .then(resp => {
        return resp.data;
      });
  }

  static repeatMCreate(repeatMCreate: RepeatMCreate) {
    return request
      .post("/aiExam/candidate/repeatMCreate", repeatMCreate)
      .then(resp => {
        return resp.data;
      });
  }
}
export class Report extends Model {
  static async getInfo(param: { connectCode: string; tid: string }) {
    return request.post("aiExam/auditPublic/version", param).then(resp => {
      return resp.data.data;
    });
  }
  static async checkPassword(param: {
    connectCode: string;
    reportCertiCode: string;
  }) {
    return request
      .post("aiExam/reportCertiCodePublic/check", param)
      .then(resp => {
        return resp.data.data;
      });
  }
  static async getDefaultCode(param: { examId: number }) {
    return request.post("aiExam/reportCertiCode/make", param).then(resp => {
      return resp.data.data;
    });
  }
  static async save(param: { reportCertiCode: string; examId: number }) {
    return request.post("aiExam/reportCertiCode/save", param).then(resp => {
      return resp.data.data;
    });
  }
  static async getCertiCode(param: {
    examId: number;
  }): Promise<{ reportCertiCode: string }> {
    return await request
      .post("aiExam/reportCertiCode/get", param)
      .then(resp => {
        return resp.data.data;
      });
  }
}
